import { render, staticRenderFns } from "./MortalityByMonthOfBirth.vue?vue&type=template&id=baa51ab0&scoped=true"
import script from "./MortalityByMonthOfBirth.vue?vue&type=script&lang=js"
export * from "./MortalityByMonthOfBirth.vue?vue&type=script&lang=js"
import style0 from "./MortalityByMonthOfBirth.vue?vue&type=style&index=0&id=baa51ab0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa51ab0",
  null
  
)

export default component.exports